import React from 'react';
import PropTypes from "prop-types";
import { Modal, Box, Typography, Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import './DeleteConfirmationModal.scss';

const DeleteConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Delete Confirmation", 
  message = "Are you sure you want to delete this item?",
  applicantNo,
  loading = false
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="DeleteConfirmationModal"
    >
      <div className="modalContainer">
        <Box sx={{ border: "0" }}>
          <button className="resetButton closeModal" onClick={onClose}>
            <HighlightOffIcon />
          </button>
          
          <div className="warningIconContainer">
            <WarningAmberIcon 
              sx={{ 
                fontSize: 60, 
                color: '#ff9800',
              }} 
            />
          </div>
          
          <Typography
            className="modalTitle"
            id="modal-modal-title"
            // component="h6"
            sx={{ textAlign: 'center', mb: 2, fontSize: '16px', fontWeight: 600 }}
          >
            {title}
          </Typography>
          
          <Typography 
            id="modal-modal-description" 
            className="modalDescription"
            sx={{ 
              textAlign: 'center', 
              mb: 3,
              color: '#666',
              fontSize: '14px',
              lineHeight: 1.5
            }}
          >
            {message}
          </Typography>
          
          <div className="modalActions">
            <Button
              variant="outlined"
              onClick={onClose}
              disabled={loading}
              sx={{
                minWidth: '120px',
                borderColor: '#D6D6D6',
                color: '#666',
                textTransform: 'none',
                '&:hover': {
                  borderColor: '#999',
                  backgroundColor: '#f5f5f5'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={onConfirm}
              disabled={loading}
              sx={{
                width: "120px",
                height: "48px",
                borderRadius: "8px",
                background: "#1A407D",
                color: "#fff",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "24px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#092552",
                },
              }}
            >
              {loading ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </Box>
      </div>
    </Modal>
  );
};



DeleteConfirmationModal.propTypes = {
  applicantNo: PropTypes.any,
  loading: PropTypes.any,
  message: PropTypes.any,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.any,
  title: PropTypes.any,
};

export default DeleteConfirmationModal;